import { Avatar, Box, Button, Drawer, Grid2, IconButton, Typography } from '@mui/material'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { ScrollContainerWithHeader } from '../../shared/components/student/ScrollComponent'
import useTabs from '../../shared/hook/useTabs'
import TabsComponent from '../../shared/components/Tabs/TabComponent'
import TabPanel from '../../shared/components/Tabs/TabPanel'
import CustomDivider from '../../shared/utils/CustomDivider'
import ProgressBar from '../../shared/components/student/ProgressBar'
import StarIcon from '@mui/icons-material/Star';
import { Frontend_URL, getFileUrl, Grid_Gap } from '../../shared/constants'
import ScheduleCalendar from '../../shared/components/trainer.js/ScheduleCalender'
import ReportCom from '../../shared/components/trainer.js/ReportCom'
import Memories from '../student/Memories'
import EventSection from '../student/EventSection'
import LingtBlueContainer, { DarkBlueContainer } from '../../shared/utils/LingtBlueContainer'
import { Icon } from '@iconify/react/dist/iconify.js'
import useDrawer from '../../shared/hook/useDrawer'
import TrainerForm from './TrainerForm'
import { useTrainerOfflineCurrentCourses, useTrainerOnlineCurrentCourses, useTrainerRating } from '../../assets/api/useTrainerGetApi'
import useAuthStore from '../../store/useAuthStore'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'
import TrainerJoinClassCard from '../../shared/components/trainer.js/TrainerJoinClassCard'
import { useGetTrainerTerms } from '../../assets/nodeApi/getApi/getTrainerApi'
import { useDialog } from '../../shared/hook/useDialog'
import { useEffect, useState } from 'react'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { patchTrainerChangeResponse } from '../../assets/nodeApi/patchApi/patchTrainerApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { useGetUserDetail } from '../../assets/api/UseStudentGetApi'
import { formatKey } from '../../shared/formatter'

const RATING_STARS = [5, 4, 3, 2, 1];


const TrainerClasses = ({ courses, isLoading }) => {
  return (
    <ScrollContainerWithHeader headerText={"Today's Classes"}>
      {!isLoading && courses?.length > 0 && (
        courses.map((item, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 6, lg: 12 }} sx={{ flex: '0 0 auto', display: "flex", alignItems: "stretch" }}>
            <TrainerJoinClassCard item={item} />
          </Grid2>
        ))
      )}

      {!isLoading && courses?.length === 0 && (
        <Typography variant="body1" sx={{ p: 2, textAlign: "center", width: "100%" }}>
          No class today.
        </Typography>
      )}

      {isLoading && (
        [...Array(1)].map((_, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 6, lg: 12 }} sx={{ flex: '0 0 auto', display: "flex", alignItems: "stretch" }}>
            <SkeletonCom />
          </Grid2>
        ))
      )}
    </ScrollContainerWithHeader>
  );
};


const Dashbaord = () => {
  const { data: userDetail } = useGetUserDetail()
  const queryClient = useQueryClient()
  const logout = useAuthStore((state) => state.logout);
  const { showToaster } = useToaster();
  const { data: trainerTerms, isLoading: isTrainerTermLoading } = useGetTrainerTerms()
  const { open: openTrainerTerm, handleClickOpen: hanldeClickOpenTrainerTerm, handleClose: handleCloseTrainerTerm } = useDialog();

  // ── Dynamic trainer ID from userDetail ────────────────────────────────────
  const trainerId = userDetail?.data?.id;

  // ── Trainer Rating (dynamic id) ───────────────────────────────────────────
  const { data: ratingData, isLoading: isRatingLoading } = useTrainerRating(trainerId);


  const averageRating = ratingData?.data?.overall?.average_rating ?? 0;
  const totalRatings = ratingData?.data?.overall?.total_ratings ?? 0;
  const distribution = ratingData?.data?.distribution ?? { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

  // ── Progress bar % per star level ─────────────────────────────────────────
  const getStarPercent = (star) => {
    if (totalRatings === 0) return 0;
    return Math.round((distribution[star] / totalRatings) * 100);
  };

  useEffect(() => {
    if (trainerTerms?.data?.status === 1) {
      hanldeClickOpenTrainerTerm()
    }
  }, [trainerTerms, isTrainerTermLoading])

  const [actionType, setActionType] = useState(null);

  const mutationUpdateResponse = useMutation({
    mutationFn: (formdata) => patchTrainerChangeResponse(formdata),
    onSuccess: (_, variables) => {
      const { trainerResponse } = variables;
      showToaster(
        `Response ${trainerResponse === 'Accepted' ? 'accepted' : 'rejected'} successfully`,
        '',
        'success'
      );
      queryClient.removeQueries({ queryKey: ["trainerUp/terms"], exact: false });
      queryClient.refetchQueries({ queryKey: ["trainerUp/terms"], exact: false });
      handleCloseTrainerTerm();

      if (trainerResponse === 'Rejected') {
        logout();
        const currentPath = window.location.pathname;
        window.location.href = `${Frontend_URL}?redirect=${encodeURIComponent(currentPath)}`;
      }
    },
    onError: (err) => {
      showToaster(err?.response?.data?.error || 'Failed to update response', '', 'error');
    },
  });

  const { user } = useAuthStore();
  const { open, toggleDrawer } = useDrawer();
  const { value: reportValue, handleChange: reportHandleChange } = useTabs(0);
  const { data: trainerCurrentOnlineCourses, isLoading: isOnlineCurrentCoursesLoading } = useTrainerOnlineCurrentCourses({ trainer_id: user?.id });
  const { data: trainerCurrentOfflineCourses, isLoading: isofflineCurrentCoursesLoading } = useTrainerOfflineCurrentCourses({ trainer_id: user?.id });
  const courses = [
    ...(trainerCurrentOfflineCourses?.data || []),
    ...(trainerCurrentOnlineCourses?.data || [])
  ];

  const Reporttabs = [
    { label: "All", component: <ReportCom /> },
    { label: "Active", component: <ReportCom /> }
  ];

  return (
    <Box>

      <CustomDivider />
      <Grid2 container spacing={"15px"}>
        <Grid2 children size={{ xs: 12, md: 6.5 }}>
          <TrainerClasses courses={courses} isLoading={isofflineCurrentCoursesLoading && isOnlineCurrentCoursesLoading} />

        </Grid2>

        {/* ── Rating Section ─────────────────────────────────────────────── */}
        
        <Grid2 children size={{ xs: 12, sm: 6, lg: 3 }}>
          <NormalContainerWithHeader>
            <Box>
              <Typography variant='h4' textAlign={"center"}>Your Review</Typography>

              <Box sx={{ display: "flex", justifyContent: "center", gap: 1, my: 1 }}>
                <StarIcon sx={{ color: "yellow.light", fontSize: "50px" }} />
                <Box>
                  {isRatingLoading ? (
                    <Typography variant='h5'>Loading...</Typography>
                  ) : (
                    <>
                      <Typography variant='h3' fontWeight={500}>
                        {averageRating > 0 ? averageRating.toFixed(1) : "0"} ⭐
                      </Typography>
                      <Typography variant='body2'>
                        Based on {totalRatings} {totalRatings === 1 ? "rating" : "ratings"}
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>

              {/* ── Star Distribution Bars ─────────────────────────────── */}
              {RATING_STARS.map((star) => (
                <Box key={star}>
                  <Typography
                    variant='body2'
                    sx={{ display: "flex", alignItems: 'center', justifyContent: "end", gap: 0.5, mb: 0.5 }}
                  >
                    {star}
                    <StarIcon sx={{ color: "yellow.light", fontSize: "16px" }} />
                  </Typography>
                  <ProgressBar value={getStarPercent(star)} bgcolor={"blue.main"} />
                </Box>
              ))}
            </Box>
          </NormalContainerWithHeader>
        </Grid2>

        <Grid2 container size={{ xs: 12, sm: 6, lg: 2.5 }}>
          <Grid2 children size={12}>
            <NormalContainerWithHeader isGrid={false}>
              <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                <IconButton onClick={() => toggleDrawer(true)}>
                  <Avatar src={getFileUrl(userDetail?.data?.profile_image)} alt='tranner avatar' sx={{ width: "70px", height: "70px" }} />
                </IconButton>

                <Typography variant='h5' my={1}>{userDetail?.data?.firstname} {""} {userDetail?.data?.lastname}</Typography>
                <Typography variant='h6' fontWeight={300}>Trainer</Typography>
              </Box>


            </NormalContainerWithHeader>
          </Grid2>
          <Grid2 children size={12}>

            <LingtBlueContainer direction={"row"} sx={{ gap: 2 }}>
              <DarkBlueContainer>
                <Icon icon="fluent:money-20-regular" color='#4169E1' width="60px" height="60px" />
              </DarkBlueContainer>
              <Box>
                <Typography variant='body1' color='blue.main' mt={1}>Total Payout</Typography>
                <Typography variant='body2' color='blue.main' sx={{ fontWeight: 600 }}>Coming Soon...</Typography>
              </Box>
            </LingtBlueContainer>
          </Grid2>
        </Grid2>
      </Grid2>
      <CustomDivider />
      <Grid2 container spacing={"15px"}>
        <Grid2 children size={{ xs: 12, lg: 6 }}>
          <NormalContainerWithHeader headerText={"Report"}>
            <TabsComponent tabs={Reporttabs} value={reportValue} onChange={reportHandleChange} />
            {Reporttabs.map((tab, index) => (
              <TabPanel key={index} value={reportValue} index={index}>
                {tab.component}
              </TabPanel>
            ))}
          </NormalContainerWithHeader>

        </Grid2>
        <Grid2 children size={{ xs: 12, lg: 6 }}>
          <NormalContainerWithHeader headerText={"Schedules"}>
            <ScheduleCalendar />
            <CustomDivider />
          </NormalContainerWithHeader>
        </Grid2>
      </Grid2>
      <CustomDivider />
      <Memories />
      <CustomDivider orientation='horizontal' />
      <EventSection />
      <CustomDivider orientation='horizontal' />
      <Drawer anchor="right" open={open} onClose={() => toggleDrawer(false)}>
        <Box sx={{ width: { lg: "40vw", xs: "100%" } }}>
          <TrainerForm onClose={() => toggleDrawer(false)} />
        </Box>
      </Drawer>



      <MainDialogBox
        open={openTrainerTerm}
        handleClose={handleCloseTrainerTerm}
        width={"40%"}
        isShowClose={false}
        heading={"Check the Terms"}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
      >

        <Box>
          {Object.entries({
            ...trainerTerms?.data?.salary,
            ...trainerTerms?.data?.terms
          } ?? {})
            .filter(([key, value]) =>
              value !== null &&
              !["id", "created_at", "updated_at"].includes(key)
            )
            .map(([key, value]) => {
              const displayValue = Array.isArray(value)
                ? value.join(", ")
                : ` ${value} `;

              return (
                <Box display="flex" alignItems="center" key={key} mb={1}>
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    sx={{ width: "35%", display: "inline-block" }}
                  >
                    {formatKey(key)}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{ width: "5%", textAlign: "center" }}
                  >
                    :
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{ width: "50%", wordBreak: "break-word" }}
                  >
                    {displayValue}
                  </Typography>
                </Box>
              );
            })}



        </Box>
        <CustomDivider />

        <Grid2 container spacing={Grid_Gap}>

          <Grid2 size={6}>
            <Button
              fullWidth
              variant="contained"
              disabled={mutationUpdateResponse.isPending && actionType === 'Accepted'}
              onClick={() => {
                setActionType('Accepted');
                mutationUpdateResponse.mutate({ trainerResponse: 'Accepted' });
              }}
            >
              {mutationUpdateResponse.isPending && actionType === 'Accepted'
                ? 'Accepting...'
                : 'Accept'}
            </Button>
          </Grid2>
          <Grid2 size={6}>
            <Button
              fullWidth
              variant="outlined"
              disabled={mutationUpdateResponse.isPending && actionType === 'Rejected'}
              onClick={() => {
                setActionType('Rejected');
                mutationUpdateResponse.mutate({ trainerResponse: 'Rejected' });
              }}
            >
              {mutationUpdateResponse.isPending && actionType === 'Rejected'
                ? 'Rejecting...'
                : 'Reject'}
            </Button>
          </Grid2>
        </Grid2>

      </MainDialogBox>

    </Box>
  )
}

export default Dashbaord